import React from 'react'
import { connect } from 'react-redux'
import SlrBookingInputFields from './SlrBookingInputFields'

const SlrBookingInputFieldsContainer = (props) => {
	return <SlrBookingInputFields {...props} />
}

const mapStateToProps = ({ gsaAgent }) => ({
	gsaAgentDetails: gsaAgent
})

export default connect(
	mapStateToProps,
	null
)(SlrBookingInputFieldsContainer)
